export default {
  en: {
    'components.registration-detail-page.delete.confirm':
      'Are you sure you want to delete this registration?',
    'components.registration-detail-page.de-register.confirm':
      'Are you sure you want to de-register this registration?',
    'components.registration-detail-page.de-register.non-managed': 'non-managed',
  },
};
